import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

function getRoomFirebaseRef(roomId) {
  return firebase.database()
      .ref('buttons')
      .child(roomId)
}

function subscribeToRoomChanges(roomId, callback) {
  const roomRef = getRoomFirebaseRef(roomId)
  roomRef.on('value', (snapshot) => {
    const value = snapshot.val()
    callback(value)
  })
}

function unsubscribeToRoomChanges(roomId) {
  const roomRef = getRoomFirebaseRef(roomId)
  roomRef.off('value')
}

export {
  subscribeToRoomChanges,
  unsubscribeToRoomChanges
}